<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="인계일"
            name="period"
            :isToyear="true"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="폐기물 처리현황 목록"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- <c-btn label="올바로데이터 업로드" icon="add" @btnClicked="openUpload" /> -->
              <c-btn label="등록" icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import selectConfig from '@/js/selectConfig';
export default {
  name: 'waste-report-manage',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '인계일',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '인계번호',
            align: 'center',
            sortable: true,
            type: 'link'
          },
          {
            name: 'col4',
            field: 'col4',
            label: '폐기물 종류',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '위탁량',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col6',
            field: 'col6',
            label: '단위',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col7',
            field: 'col7',
            label: '운반자명',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col8',
            field: 'col8',
            label: '처리자명',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col9',
            field: 'col9',
            label: '처리방법',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col10',
            field: 'col10',
            label: '인계자명',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        startYmd: '',
        endYmd: '',
        plantCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '80%',
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col1: '사업장1', 
          col2: '2021-01-05', 
          col3: '012-31214', 
          col4: '폐수처리오니', 
          col5: '120', 
          col6: 'kg', 
        },
        {
          col1: '사업장1', 
          col2: '2021-01-03', 
          col3: '23-124', 
          col4: '폐합성수지류', 
          col5: '220', 
          col6: 'kg', 
        },
      ];
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    openUpload() {
      this.popupOptions.target = () => import(`${"./wasteReportUpload.vue"}`);
      this.popupOptions.title = '폐기물 처리결과 업로드(올바로)';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./wasteReportManageDetail.vue"}`);
      this.popupOptions.title = '폐기물 처리현황 상세';
      this.popupOptions.param = {
        psiDocumentId: result,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
